import request from '@/services/api';
// 新增收藏,avoriteType，0是收藏店铺，1是收藏商品
export function favoriteAdd(data: any) {
  return request({
    url: 'favorite/add',
    method: 'post',
    data
  })
}
//获取店铺收藏
export function favoriteShopList() {
  return request({
    url: 'favorite/shops',
    method: 'get',
  })
}
//获取商品收藏
export function favoriteProductList() {
  return request({
    url: 'favorite/products',
    method: 'get',
  })
}
//取消店铺收藏
// @param favoriteIds 收藏ID数组
export function favoriteShopCancel(ids: any[]) {
  return request({
    url: 'favorite/deleteShop',
    method: 'delete',
    data: { ids }
  })
}
//取消商品收藏
// @param favoriteIds 收藏ID数组
export function favoriteProductCancel(ids: any[]) {
  return request({
    url: 'favorite/deleteProduct',
    method: 'delete',
    data: { ids }
  })
}
